module.exports = __webpack_public_path__ + "static/media/box_steps.741ce65a.jpg";